"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BadgeSimpleColors = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      "& .MuiBadge-dot": {
        width: 10,
        height: 10,
        borderRadius: 10
      },
      "& .MuiBadge-badge": {
        padding: 0,
        alignItems: "center",
        justifyContent: "center"
      }
    },
    neutral: {
      "& .MuiBadge-badge": {
        backgroundColor: theme.palette.warning.main
      }
    },
    positive: {
      "& .MuiBadge-badge": {
        backgroundColor: theme.palette.success.main
      }
    },
    critical: {
      "& .MuiBadge-badge": {
        backgroundColor: theme.palette.error.main
      }
    }
  };
});
/**
 * **Badge is a decorative indicator used to either call attention to a related item or which hold small amounts of information.**
 *
 * There are 3 colours: Positive, Neutral, Critical
 *
 */

var BadgeSimple = function BadgeSimple(_ref) {
  var _classNames;

  var color = _ref.color,
      children = _ref.children;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Badge, {
    variant: "dot",
    className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, styles.root, true), _defineProperty(_classNames, styles[color], true), _classNames))
  }, children);
};

BadgeSimple.propTypes = {
  /** The available colors of the badge */
  color: _propTypes.default.oneOf(["positive", "neutral", "critical"]),

  /** The children element that will place the badge on top */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node])
};
BadgeSimple.defaultProps = {
  color: "positive",
  children: null
};
var BadgeSimpleColors = ["positive", "neutral", "critical"];
exports.BadgeSimpleColors = BadgeSimpleColors;
var _default = BadgeSimple;
exports.default = _default;